// extracted by mini-css-extract-plugin
module.exports = {"Main":"Main_Main__3SBK4","Margin":"Main_Margin__2G0z1","start":"Main_start__2fdMR"};